<template>
    <div class="btn-group-box">
        <a
            :href="ytbUrl"
            target="_blank"
            v-show="null != ytbUrl && '' !== ytbUrl"
        >
            <div class="video-share-btn">
                <font-awesome-icon icon="fa-brands fa-square-youtube" style="color: #ff0000;" />
            </div>
        </a>

        <a
            :href="fbUrl"
            target="_blank"
            v-show="null != fbUrl && '' !== fbUrl"
        >
            <div class="video-share-btn">
                <font-awesome-icon icon="fa-brands fa-square-facebook" style="color: #223662;" />
            </div>
        </a>

        <a
            :href="tiktokUrl"
            target="_blank"
            v-show="null != tiktokUrl && '' !== tiktokUrl"
        >
            <div class="video-share-btn">
                <img :src="publicPath + 'static/images/tiktok.png'" class="share-btn-img" alt="tiktok">
            </div>
        </a>

        <a
            :href="redUrl"
            target="_blank"
            v-show="null != redUrl && '' !== redUrl"
        >
            <div class="video-share-btn">
                <img :src="publicPath + 'static/images/icon-red.png'" class="share-btn-img" alt="red">
            </div>
        </a>
    </div>
</template>

<script setup>

    const props = defineProps(["ytbUrl", "fbUrl", "tiktokUrl", "redUrl"])
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faSquareYoutube, faSquareFacebook } from '@fortawesome/free-brands-svg-icons'

    library.add(faSquareYoutube, faSquareFacebook)

    const publicPath = process.env.BASE_URL

</script>

<style scoped>

.btn-group-box {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.video-share-btn {
    width: 40px;
    height: 40px;
    text-align: center;
    /* background: none; */
    padding: 0;
    font-size: 40px;
    display: inline;
    margin-right: 8px;
    cursor: pointer;
}

.video-share-btn .share-btn-img {
    width: 36px;
    height: 36px;
    border-radius: 5px;
    margin-top: 5px;
}

</style>